/** @prettier */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { navigatedToPage } from '../actions/segmentEvents';

/**
 * @description Sends a page call event to segment.
 * @param {String} pageName
 * @param {Object} properties A memoized version of the properties object
 * **do not define inline or else the page call will fire every re-render**
 */
export function usePageCall(pageName, properties) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(navigatedToPage(pageName, properties))
  }, [dispatch, pageName, properties])
}
